import store from "../store/index";

export default (to, from, next) => {
    if (!store.state.auth.token) {
        return next({
            name: "login",
            params: {
                r: to.path,
            },
        });
    }

    next();
};
